export const forwardSlashCheck = (href: string) => {
  const hasForwardSlash = href.charAt(0) === '/';

  if (!hasForwardSlash) {
    return `/${href}`;
  }

  return href;
};
